import { _types } from "../types";
const { STATE, CLEAR, SUCCESS, FAILD, SPONSOR_ITEMS, SPONSOR_TYPES } = _types;
const initState = {
  sponsor_isProgress: false,
  sponsor_isError: false,
  sponsor_errorText: "",
  sponsor_successText: "",  
  sponsorTypes:null,
  sponsorItems: null,
};

function sponsorReducer(state = initState, action) {
    switch (action.type) {
        case SPONSOR_TYPES + SUCCESS:
            return {
                ...state,
                sponsor_isProgress: false,
                sponsor_isError: false,
                sponsor_errorText: "",
                sponsor_successText: "",
                sponsorTypes:action.payload,
            };
        
        case SPONSOR_TYPES + FAILD:
            return {
                ...state,
                sponsor_isProgress: false,
                sponsor_isError: true,
                sponsor_errorText: "",
                sponsor_successText: "",
            };               

        case SPONSOR_ITEMS + SUCCESS:
            return {
                ...state,
                sponsor_isProgress: false,
                sponsor_isError: false,
                sponsor_errorText: "",
                sponsor_successText: "",
                sponsorItems: action.payload,
            };
        
        case SPONSOR_ITEMS + FAILD:
            return {
                ...state,
                sponsor_isProgress: false,
                sponsor_isError: true,
                sponsor_errorText: "",
                sponsor_successText: "",
            };

        case STATE + CLEAR:
            return {
                ...state,
                sponsor_isProgress: false,
                sponsor_isError: false,
                sponsor_errorText: "",
                sponsor_successText: "",
            };

        default:
            return state;
    }
}

export default sponsorReducer;